export default {
  SET_BOARDMEMBERS(state, data) {
    state.boardMembers = data;
  },
  SET_OFFICERS(state, data) {
    state.officers = data;
  },
};
